document.querySelectorAll('.rcl__nav-wrap').forEach((wrap) => {
  const row = wrap.querySelector('[data-rcl-row]');
  const prev = wrap.querySelector('[data-rcl-prev]');
  const next = wrap.querySelector('[data-rcl-next]');
  if (!row || !prev || !next) return;

  function update() {
    const max = row.scrollWidth - row.clientWidth;
    const overflowing = max > 4;

    prev.hidden = !overflowing;
    next.hidden = !overflowing;

    if (overflowing) {
      prev.disabled = row.scrollLeft <= 4;
      next.disabled = row.scrollLeft >= max - 4;
    }
  }

  prev.addEventListener('click', () => {
    row.scrollBy({ left: -row.clientWidth * 0.8, behavior: 'smooth' });
  });
  next.addEventListener('click', () => {
    row.scrollBy({ left: row.clientWidth * 0.8, behavior: 'smooth' });
  });

  row.addEventListener('scroll', update);
  window.addEventListener('resize', update);
  update();
});